import React, {Component} from "react";
import recordStyle from './deliveryRecord.module.less'
import urgentImg from '../../assets/img/urgent.png'
import nothingImg from '../../assets/img/nothing.png'
import waitImg from '../../assets/img/home/wait.png'
import completeImg from '../../assets/img/home/complete.png'
import errorImg from '../../assets/img/home/error.png'
import PageLoading from '../speakLoading/pageLoading'
import {PositionApi} from "../../services/positionApi.js";
import filters from "../../utils/filters";
import {SgAuthApi} from '../../services/sgAuthApi.js';

import { connect } from 'react-redux';
import {setTimerType, clearTimerType} from '../../store/actions'
let positionAi = new PositionApi();
let sgAuthApi = new SgAuthApi();

class deliveryRecord extends Component {
    constructor(props) {
        console.log(props)
        super();
        this.state = {
            positionHotData: [],
            pageOption: {
                pageSize: 10,
                pageNo: 1,
                total: 0,
                pageCount: 0
            },
            params: {},
            // indCode:props.indCode,
            // mobile: "18600912106",               //  --------------临时为了测试改成 18600912106
            mobile:props.mobile,
            listLoading:true
        }
    }

    componentDidMount() {
        console.log(this.props,'nmnm')
        this.props.setTimerType("deliveryRecord");


        if(this.state.mobile){
            this.getList(this.state.mobile);
        }else{
            /* global my */
            if (navigator.userAgent.indexOf('AlipayClient') > -1) {
                my.postMessage({type:"recordCheckFace",data:{
                    deviceId: localStorage.getItem("device_id"),
                    deviceCode: localStorage.getItem("device_code")
                }});
            }
        }

        //监听扫脸结果
        window.addEventListener('recordCheckFace', this.recordCheckFace);
    }

    reloadData=()=>{
        if(this.state.mobile){
            this.getList(this.state.mobile);
        }else{
            /* global my */
            if (navigator.userAgent.indexOf('AlipayClient') > -1) {
                my.postMessage({type:"recordCheckFace"});
            }
        }
    }

    componentWillUnmount() {
        this.props.clearTimerType();
    }

    recordCheckFace=(res)=>{

        let authCode = res.detail.data
        let obj = {
            "authCode": authCode,
            "user_type": "UT01",
            "authType": 'AUTH_CODE',
            "yae100": '14',
            "device_id": localStorage.getItem("device_id"),
            "device_code": localStorage.getItem("device_code")
        }

        // alert(JSON.stringify(obj));

        sgAuthApi.getYhUserInfo(obj).then(ret => {
            alert(JSON.stringify(ret));

            if(ret && ret.data.code === "200" && this.state.showList !== 5) {
                // alert(JSON.stringify(params))

                localStorage.setItem("yae100", ret.data.data.yae100);
                localStorage.setItem("aac001", ret.data.data.aac001);
                localStorage.setItem("token", ret.data.data.token);
                setTimeout(()=>{
                    this.getList(ret.data.data.mobile);
                },500)
            }
        })
    }

    getList=()=> {
        this.setState({
            listLoading:true
        })
        let obj={}
        obj.device_id = localStorage.getItem("device_id")
        obj.device_code = localStorage.getItem("device_code")
        obj.aac001 = localStorage.getItem("aac001");
        obj.yae100 = localStorage.getItem("yae100");
        obj.terminalJtoken = localStorage.getItem("token");

        // alert(JSON.stringify(obj))
        // if (!this.state.mobile){
        //     this.setState({
        //         mobile:obj.mobile
        //     })
        // }
        this.setState({
            params:obj
        },()=>{
            console.log(this.state.params);
            positionAi.getDeliveryRecords(obj).then(res=>{

                // alert(JSON.stringify(res));

                if (res.data.code == "200") {
                    let arr=res.data.data.list;

                    if(arr && arr.length > 0){
                        arr.map(item=>{
                            if(item.acc676 == 0 ){
                                item.currentStageTxt = "未查看";
                            }else if( item.currentStage == 1){
                                item.currentStageTxt = "已查看";
                            }else if(item.currentStage == 2){
                                item.currentStageTxt = "已安排面试";
                            }else if(item.currentStage == 3){
                                item.currentStageTxt = "不合适";
                            }
                        })
                    }

                    this.setState({
                        positionHotData : arr,
                        pageOption:{
                            ...this.state.pageOption,
                            total:  res.data.data.count,
                            pageCount : res.data.data.pageCount
                        }
                    })
                    if (arr.length<=0){
                        this.props.onChildData(1);
                    }else {
                        this.props.onChildData(2);
                    }
                }
                setTimeout(()=>{
                    this.setState({
                        listLoading:false
                    })
                },500)
            })
        })

    }

    lastPage() {
        if (this.state.pageOption.pageNo !== 1) {
            let i=this.state.pageOption.pageNo-1
            this.setState({
                pageOption: {
                    ...this.state.pageOption,
                    pageNo:i
                }
            },()=>{
                this.getList()
            })
        }
    }

    nexPage() {
        if (this.state.pageOption.pageNo < this.state.pageOption.pageCount) {
            let i=this.state.pageOption.pageNo+1
            this.setState({
                pageOption: {
                    ...this.state.pageOption,
                    pageNo:i
                }
            },()=>{
                this.getList()
            })
        }
    }

    toDetail(e){
        this.props.onData(e);
    }

    toAiInterView(item){
        let positionId = item.employmentType === 3 ? item.positionId : item.positionHroId
        this.props.callParentMethod(positionId, item.employmentType,item.projectId,item.resumeId);
    }

    // 去除数字末尾的.0
    removeTrailingZero = (value) => {
        if (value === null || value === undefined) {
            return '';
        }
        const str = String(value);
        return str.endsWith('.0') ? str.slice(0, -2) : str;
    }

    render() {
        return (
            <div className={recordStyle.deliveryRecord}>
                {/*<p>报名记录（{this.state.pageOption.total?this.state.pageOption.total:0}）</p>*/}
                <p></p>
                {
                    this.state.listLoading?(
                        <div className={recordStyle.loading}>
                            <PageLoading></PageLoading>
                        </div>
                    ):(
                        this.state.positionHotData.length > 0 ? (
                            <div className={recordStyle.content}>
                                <div className={recordStyle.listScroll}>
                                    <div className={recordStyle.list}>
                                        {
                                            this.state.positionHotData.map((item ,index)=> {
                                                return(
                                                    <div className={recordStyle.listContent} key={index} >
                                                        <div className={recordStyle.listConTitle}>
                                                            <div className={recordStyle.positionDetail}>
                                                                <div className={recordStyle.topTitle}>
                                                                    <h2 className={recordStyle.positionName}>{item.acb213}</h2>
                                                                    {
                                                                        item.isUrgent == 1 ? (
                                                                            <img src={urgentImg} className={recordStyle.urgent} alt=""/>
                                                                        ) : ('')
                                                                    }
                                                                </div>
                                                                <div className={recordStyle.btn}>
                                                                    {
                                                                        <p className={`${recordStyle.btnStatus} ${recordStyle.btnOne}`}>
                                                                            {item.currentStageTxt}
                                                                        </p>
                                                                    }
                                        

                                                                </div>
                                                            </div>
                                                            <aside className={recordStyle.bottomDetail}>
                                                                <section className={recordStyle.company}>
                                                                    <div className={`${recordStyle.typeTxt} ${recordStyle.typeTxt1}`}>
                                                                        {
                                                                            <p className={recordStyle.strContent}>{item.aab004 ? item.aab004 : '未填写'}</p>
                                                                        }
                                                                        {
                                                                            <p className={recordStyle.strContent}>| {item.acb469_dsc}</p>
                                                                        }
                                                                       
                                                                        <p className={recordStyle.strContent}>
                                                                            | {item.aac011_dsc}
                                                                        </p>
                                                                        <p className={recordStyle.strContent}>
                                                                            | {item.acc217_dsc}
                                                                        </p>
                                                                    </div>
                                                                </section>
                                                            </aside>
                                                            <div className={recordStyle.itemBottom}>
                                                                <div className={recordStyle.salary}>
                                                                    {
                                                                        <b className={recordStyle.salaryItem}>
                                                                            {this.removeTrailingZero(item.acb21h)}-{this.removeTrailingZero(item.acb21j)}元
                                                                        </b>
                                                                    }

                                                                </div>
                                                                <p className={recordStyle.time}>{filters.getDateShowText(item.aae052,'yyyy.MM.dd hh:mm')}</p>
                                                            </div>


                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                        <div className={recordStyle.blockHeight}></div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className={recordStyle.list}>
                                <div className={recordStyle.notList}>
                                    <img src={nothingImg} alt=""/>
                                    <p>暂无报名记录</p>
                                    <span>去找份合适的职位报名吧！</span>
                                </div>
                            </div>
                        )
                    )
                }
            </div>
        )
    }
}
const mapDispatchToProps = dispatch => ({
    setTimerType: (timerType) => {
        console.log(timerType,'opolp')
        dispatch(setTimerType(timerType))
    },
    clearTimerType: () => dispatch(clearTimerType())
});

export default connect(null, mapDispatchToProps,null,{ forwardRef: true } )(deliveryRecord);
// export default deliveryRecord;